import Tooltip from "rc-tooltip";
import React, { useCallback, useMemo } from "react";
import { RouteComponentProps } from "react-router-dom";
import Copy from "../../../components/Copy";
import ExternalLink from "../../../components/ExternalLink";
import InfoIcon from "../../../components/icons/InfoIcon";
import InfoItems from "../../../components/InfoItems";
import { useLocations } from "../../../context/locations";
import { formatDateToLocale } from "../../../utils/dates";
import { HotspotLocation } from "../../../utils/types";
import useMapConfig from "../../../utils/useMapConfig";
import MemberCell from "../../Workspace/common/MemberCell";

const LocationInfoTab: React.FC<RouteComponentProps<{ id: string }>> = (
  props
) => {
  const { currentLocation, locations } = useLocations();
  const renderDistance = useMapConfig((state) => state.renderDistance);

  const location = useMemo(
    () =>
      currentLocation ||
      (props.match.params.id ? locations[props.match.params.id] : undefined),
    [currentLocation, locations, props.match.params.id]
  );

  const getInfoItems = useCallback(
    ({
      created_at,
      updated_at,
      created_by,
      updated_by,
      lat,
      lng,
      height,
      address
    }: HotspotLocation) => [
      {
        label: "Added",
        value: (
          <MemberCell
            memberUuid={created_by}
            subtitle={formatDateToLocale(created_at)}
          />
        )
      },
      {
        label: "Updated",
        value: updated_by ? (
          <MemberCell
            memberUuid={updated_by}
            subtitle={formatDateToLocale(updated_at)}
          />
        ) : null
      },
      {
        label: (
          <>
            Coordinates
            {lat && lng && (
              <Copy
                text={`${lat},${lng}`}
                label="coordinates"
                className="inline ml-1 h-4 w-4 text-gray-500"
              />
            )}
          </>
        ),
        value: (
          <>
            {`${lat},${lng}`}

            {lat && lng && (
              <ExternalLink
                text="Google Earth"
                url={`https://earth.google.com/web/search/${lat},${lng}/`}
              />
            )}
          </>
        )
      },
      {
        label: (
          <>
            Installation height
            <Tooltip overlay="Antenna height above the ground">
              <InfoIcon className="ml-1 inline-flex h-4 w-4" />
            </Tooltip>
          </>
        ),
        value: height ? renderDistance(height, false) : null
      },
      {
        label: (
          <>
            Address
            {address && (
              <Copy
                text={address}
                label="address"
                className="inline ml-1 h-4 w-4 text-gray-500"
              />
            )}
          </>
        ),
        value: address?.split(", ").map((namePart, j) => (
          <span key={`${namePart}-${j}`} className="block">
            {namePart.replace(",", "")}
          </span>
        ))
      }
    ],
    [renderDistance]
  );

  return <InfoItems infoItems={location ? getInfoItems(location) : []} />;
};

export default LocationInfoTab;
